import { render } from "./index.vue?vue&type=template&id=54c4fedf&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=54c4fedf&lang=css"
import "./index.vue?vue&type=style&index=1&id=54c4fedf&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c4fedf"]])

export default __exports__